<p-toast></p-toast>
<div class="card">
    @if (!isDialog) {
    <!-- Breadcrumb Navigation -->

    <!-- Dynamic Page Title -->
    <div class="flex align-items-center mt-4 mb-4">
        <i class="pi pi-building-columns mr-3 text-2xl text-primary"></i>
        <h2 class="font-medium text-2xl text-900 m-0">
            {{ editMode ? 'Edit Bank Account' : 'New Bank Account' }}
        </h2>
    </div>
    }

    <form [formGroup]="bankAccountEntryForm">
        <p-fieldset legend="Bank & Account Details" [toggleable]="true" styleClass="surface-ground">
            <div class="p-fluid formgrid grid">
                <!-- Bank -->
                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-globe"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select id="bank" formControlName="bank" [options]="banks" [filter]="true" filterBy="name"
                                [showClear]="true" styleClass="w-full">
                                <ng-template let-bank pTemplate="selectedItem">
                                    @if (bank) {
                                    <div class="flex align-items-center gap-2">
                                        <img [src]="bank.logoUrl ?? 'https://placehold.co/20x20/EFEFEF/A0AEC0?text=B'"
                                            style="width: 20px; height: 20px; vertical-align: middle" />
                                        <div>{{ bank.name }}</div>
                                    </div>
                                    }
                                </ng-template>
                                <ng-template let-bank pTemplate="item">
                                    <div class="flex align-items-center gap-2">
                                        <img [src]="bank.logoUrl ?? 'https://placehold.co/20x20/EFEFEF/A0AEC0?text=B'"
                                            style="width: 20px; height: 20px; vertical-align: middle" />
                                        <div>{{ bank.name }}</div>
                                    </div>
                                </ng-template>
                            </p-select>
                            <label for="bank">Bank</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <!-- Account Name -->
                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-user"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="accountName" pInputText formControlName="accountName" />
                            <label for="accountName">Account Name</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <!-- Account Number -->
                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-hashtag"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="accountNumber" pInputText formControlName="accountNumber" />
                            <label for="accountNumber">Account Number</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <!-- IBAN -->
                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-credit-card"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="iban" pInputText formControlName="iban" />
                            <label for="iban">IBAN</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <!-- Currency -->
                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-dollar"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select id="currencyCode" formControlName="currencyCode" [options]="currencies"
                                styleClass="w-full"></p-select>
                            <label for="currencyCode">Currency</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
            </div>
        </p-fieldset>
    </form>

    <!-- Action Buttons -->
    <div class="mt-4 flex justify-content-end gap-2">
        <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Save" icon="pi pi-check" (click)="saveBankAccount()" [loading]="isLoading" [disabled]="!canSave"></p-button>
    </div>
</div>
